/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Plan_ProInputs */



/**
* | output |
* | --- |
* | "Pro" |
*
* @param {Signup_Plan_ProInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_plan_pro = /** @type {((inputs?: Signup_Plan_ProInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Plan_ProInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Pro")
	if (locale === "de") return /** @type {LocalizedString} */ ("Pro")
	if (locale === "it") return /** @type {LocalizedString} */ ("Professionista")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Про")
	if (locale === "es") return /** @type {LocalizedString} */ ("Pro")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("专业版")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रो")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Pró")
	return /** @type {LocalizedString} */ ("Pro")
});